import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "onsip-video-checkbox-view",
  templateUrl: "./video-checkbox-view.component.html",
  styleUrls: ["../sayso-topic-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VideoCheckboxViewComponent {
  @Input() video: boolean | undefined;
}
